/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Description_AriaInputs */

const en_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export audio description with synthetic voice`)
};

const fr_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la description audio avec voix synthetique`)
};

const de_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren Sie die Audiobeschreibung mit synthetischer Stimme`)
};

const it_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta descrizione audio con voce sintetica`)
};

const ru_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт аудиоописания с синтезированным голосом`)
};

const es_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar audiodescripción con voz sintética`)
};

const zh_cn2_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出带有合成语音的音频描述`)
};

const ja_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合成音声による音声解説をエクスポートする`)
};

const hi_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृत्रिम आवाज के साथ ऑडियो विवरण निर्यात करें`)
};

const pt_pt2_file_export_audio_description_aria = /** @type {(inputs: File_Export_Audio_Description_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar audiodescrição com voz sintética`)
};

/**
* | output |
* | --- |
* | "Export audio description with synthetic voice" |
*
* @param {File_Export_Audio_Description_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_description_aria = /** @type {((inputs?: File_Export_Audio_Description_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Description_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_audio_description_aria(inputs)
	if (locale === "de") return de_file_export_audio_description_aria(inputs)
	if (locale === "it") return it_file_export_audio_description_aria(inputs)
	if (locale === "ru") return ru_file_export_audio_description_aria(inputs)
	if (locale === "es") return es_file_export_audio_description_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_audio_description_aria(inputs)
	if (locale === "ja") return ja_file_export_audio_description_aria(inputs)
	if (locale === "hi") return hi_file_export_audio_description_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_audio_description_aria(inputs)
	return en_file_export_audio_description_aria(inputs)
});